import styled from 'styled-components';

export const ToolGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;
